import { ApiBase } from 'api/api'
import { makePutRequest } from 'api/fetchCalls'
import type { StripeCustomerUpdateParams } from 'types/payments'

export const updateStripeCustomer = async (
  id: string,
  data: StripeCustomerUpdateParams
): Promise<undefined> => {
  return await makePutRequest(`${ApiBase}/payments/customer/${id}`, {
    body: JSON.stringify(data),
  })
}
